import * as React from "react";

function SvgDragHandleIndicator(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 8 32" fill="none" {...props}>
      <path opacity={0.5} d="M0 0h8v32H0V0z" fill="#fff" />
      <circle cx={4} cy={4} r={1} fill="#393939" />
      <circle cx={4} cy={8} r={1} fill="#393939" />
      <circle cx={4} cy={12} r={1} fill="#393939" />
      <circle cx={4} cy={16} r={1} fill="#393939" />
      <circle cx={4} cy={20} r={1} fill="#393939" />
      <circle cx={4} cy={24} r={1} fill="#393939" />
      <circle cx={4} cy={28} r={1} fill="#393939" />
    </svg>
  );
}

export default SvgDragHandleIndicator;
